import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Pages/Home";
import "./Styles/Global.css";
import AboutUs from "./Pages/AboutUs";
import MyProperty from "./Pages/MyProjects";
import Services from "./Pages/Service";
import ResidentDetailPage from "./Pages/DetailPage/ResidentDetailPage";
import RentDetailPage from "./Pages/DetailPage/RentDetailPage";
import CommercialDetailPage from "./Pages/DetailPage/CommercialDetailPage";
import ContactUs from "./Components/Forms/Contactus";
import Footer from "./Components/Footer";
import Blog from "./Pages/Blog/Blog";
import BlogDetail from "./Pages/Blog/BlogDetail";
import AllCommentsPage from "./Pages/Blog/AllCommentPage";
import ScrollToTop from "./Components/ScrollToTop";
import TermsAndConditions from "./Components/TermsAndConditions";
import PrivacyPolicy from "./Components/PrivacyPolicy";

function App() {
  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/my-projects" element={<MyProperty />} />
        <Route path="/our-services" element={<Services />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
        <Route path="/blogs/:blogId/comments" element={<AllCommentsPage />} />
        <Route
          path="/residential-property/:id"
          element={<ResidentDetailPage />}
        />
        <Route path="/rent-property/:id" element={<RentDetailPage />} />
        <Route
          path="/commercial-property/:id"
          element={<CommercialDetailPage />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
